import React 			from 'react';
import BLComponent 		from '../../core/_BLComponent.jsx';
import {CustomAlert, HoverShowTooltip, HoverHideTooltip} 	from '../../common/_Utilities.jsx';

import BDPPurchasingBlock from './_BDPPurchasingBlock.jsx';
import BDPPricingBlock from './_BDPPricingBlock.jsx';

export default class BDPSubmissionCard extends BLComponent {
	constructor(props) {
		super(props);

		this.state = {
			vote: blapp.models.get('myVote') || 0
		}
	}

	componentDidMount() {
		if(this.props.hasVoting) {
			this.fetchPersonalizeData();
		}
	}

	componentWillUnmount() { 
		super.componentWillUnmount(); 
		if ( this._callbackRegistered != null )
			blapp.personalized.unregisterCallback( this._callbackRegistered );
	}

	render() {
		const {classes = '', data, hasVoting = true, hasPricing = false, crossSell = false, salesInfo, hidePurchase = false, quickViewFunc = false, hasInstructions = false, hasTag = false} = this.props;
		const designer = this.returnDesigner(data.dmUserBuilder.dmUser);
		const bgImage = data.arrImages.length > 1 ? data.arrImages[1].dmThumbnail : data.arrImages[0] ? data.arrImages[0].dmThumbnail : {bgImage: ''}
		const mainImage = data.arrImages[0] ? data.arrImages[0].dmThumbnail : {url: ''};

		const isCrowdfunding = data.typeStage == 'FINALIST' && blapp.config.server_time >= data.dmBDPSeries.udtCrowdFundingStart;

		if(isCrowdfunding && !crossSell) {
			return (
				<article className={`card bdp-submission-card ${classes}`} data-ts-name="bdp-submission-card" data-ts-id={data.idSubmission}>
					<div className="card__internal bdp-submission-card__internal">
						{hasPricing || hasTag && this.renderTag()}
						<a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="bdp-submission-card__image" style={{backgroundImage: `url(${bgImage.url})`}}>
							<div className="bdp-submission-card__image-internal" style={{backgroundImage: `url(${mainImage.url})`}}>
								<img className="bdp-submission-card__image-item" src={mainImage.url}/>
							</div>
						</a>
						<div className="bdp-submission-card__main">
							<h2 className="bdp-submission-card__title" data-ts-name="bdp-submission-card__set-name"><a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="text--inherit">{blapp.util.decodeHtml(data.strSubmissionName)}</a></h2>
							<div className="bdp-card__designer bdp-submission-card__designer">
								<div className="bdp-card__designer-image" data-ts-name="bdp-submission-card__designer-image">
									<img src={designer.image}/>
								</div>
								<p className="bdp-card__designer-name" data-ts-name="bdp-submission-card__designer-name">{designer.name}</p>
							</div>
							{hasInstructions ? <button className="btn btn--cta l-margin-bottom text--bold text--small-title" onClick={() => this.props.instructionsModal(data.idSubmission)}>Building instructions<i className="far fa-book-open l-margin-left"/></button> : null}
							{hasPricing ? 
								<BDPPurchasingBlock hidePurchase={hidePurchase} data={data} salesInfo={salesInfo}/>
							:
								<a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="bdp-purchasing__cta" data-ts-name="bdp-purchasing__view-details">
									View details<i className="far fa-long-arrow-right l-margin-left--sm"/>
								</a>
							}
						</div>
					</div>
				</article>
			);
		}else{
			return (
				<article className={`card bdp-submission-card ${classes}`} data-ts-name="bdp-submission-card" data-ts-id={data.idSubmission}>
					<div className="card__internal bdp-submission-card__internal">
						{this.renderTag()}
						<a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="bdp-submission-card__image" style={{backgroundImage: `url(${bgImage.url})`}}>
							<div className="bdp-submission-card__image-internal" style={{backgroundImage: `url(${mainImage.url})`}}>
								<img className="bdp-submission-card__image-item" src={mainImage.url}/>
							</div>
						</a>
						<div className="bdp-submission-card__main">
							<h2 className="bdp-submission-card__title" data-ts-name="bdp-submission-card__set-name"><a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="text--inherit">{blapp.util.decodeHtml(data.strSubmissionName)}</a></h2>
							<div className="bdp-card__designer bdp-submission-card__designer">
								<div className="bdp-card__designer-image" data-ts-name="bdp-submission-card__designer-image">
									<img src={designer.image}/>
								</div>
								<p className="bdp-card__designer-name" data-ts-name="bdp-submission-card__designer-name">{designer.name}</p>
							</div>
							{hasPricing ? <BDPPricingBlock hidePurchase={hidePurchase} salesInfo={salesInfo}/> : null}
							<a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="bdp-submission-card__cta text--bold" data-ts-name="bdp-submission-card__view-details">
								View details<i className="far fa-long-arrow-right l-margin-left--sm"/>
							</a>
							{quickViewFunc ? <button className="l-full-width text--underline btn btn--link text-color--darkestBlue l-margin-top--sm" onClick={() => this.props.quickViewFunc(data.idSubmission)}>Quick view</button> : null}
							{hasVoting ? this.renderVoting() : null}
						</div>
					</div>
				</article>
			);
		}
	}

	renderTag() {
		const {data, salesInfo} = this.props;

		if(!salesInfo) {
			if(data.typeStage == 'FINALIST') {
				return (
					<div className="bdp-submission-card__award card-icon-tag card-icon-tag--bdp-finalist js-top-right-tooltip" data-tooltip={'Finalist'} data-tooltip-classname="text--center" data-tooltip-width={70} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}><i className="fas fa-award-simple"/></div>
				);
			}else{
				return;
			}
		}

		if(data.typeStage != 'FINALIST') {
			return;
		}
		
		if(salesInfo.stock && (salesInfo.stock.bSoldOut || salesInfo.stock.dPercentagePreordered >= 1)) {
			return (
				<section className="bdp-submission-card__award">
					<div className="card-icon-tag card-icon-tag--sold-out bdp-submission-card__sales-status bdp-submission-card__sales-status--sold-out">Sold Out</div>
					<div className="card-icon-tag card-icon-tag--bdp-finalist js-top-right-tooltip" data-tooltip={'Finalist'} data-tooltip-classname="text--center" data-tooltip-width={70} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}><i className="fas fa-award-simple"/></div>
				</section>
			);
		}else if(salesInfo.stock && salesInfo.stock.bFunded) {
			return (
				<section className="bdp-submission-card__award">
					<div className="card-icon-tag card-icon-tag--funded bdp-submission-card__sales-status bdp-submission-card__sales-status--funded">Funded</div>
					<div className="card-icon-tag card-icon-tag--bdp-finalist js-top-right-tooltip" data-tooltip={'Finalist'} data-tooltip-classname="text--center" data-tooltip-width={70} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}><i className="fas fa-award-simple"/></div>
				</section>
			);
		}else{
			return (
				<div className="bdp-submission-card__award card-icon-tag card-icon-tag--bdp-finalist js-top-right-tooltip" data-tooltip={'Finalist'} data-tooltip-classname="text--center" data-tooltip-width={70} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}><i className="fas fa-award-simple"/></div>
			);
		}
	}

	returnDesigner(user) {
		return {image: blapp.url2.getProfileImgUrl(user, 'medium'), name: user.skUsername};
	}

	renderVoting() {
  	const isPostValidation = blapp.config.server_time > this.props.data.dmBDPSeries.udtCrowdValidationEnd;
  	const designsAnnounced = blapp.config.server_time > this.props.data.dmBDPSeries.udtDesignsAnnounced;

  	if(!designsAnnounced) {
			return (
				<section className={"bdp-submission-card__voting" + (isPostValidation ? ' bdp-submission-card__voting--disabled' : '')}>
					<button className={`bdp-submission-card__vote-item ${this.state.vote == 1 ? 'bdp-submission-card__vote-item--active' : ''} js-bottom-center-tooltip`} data-tooltip={"Not for me"} data-tooltip-width={90} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e, 'fast')} onClick={() => this.vote(1)}>
						<img className="bdp-submission-card__vote-item-image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-1.png`}/>
					</button>
					<button className={`bdp-submission-card__vote-item ${this.state.vote == 2 ? 'bdp-submission-card__vote-item--active' : ''} js-bottom-center-tooltip`} data-tooltip={"Like it"} data-tooltip-width={90} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e, 'fast')} onClick={() => this.vote(2)}>
						<img className="bdp-submission-card__vote-item-image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-2.png`}/>
					</button>
					<button className={`bdp-submission-card__vote-item ${this.state.vote == 3 ? 'bdp-submission-card__vote-item--active' : ''} js-bottom-center-tooltip`} data-tooltip={"Love it"} data-tooltip-width={90} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e, 'fast')} onClick={() => this.vote(3)}>
						<img className="bdp-submission-card__vote-item-image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-3.png`}/>
					</button>
				</section>
			);
		}
	}

	vote(vote) {
  	const isPostValidation = blapp.config.server_time > this.props.data.dmBDPSeries.udtCrowdValidationEnd;
		
		if(isPostValidation) {
			return false;
		}else{
			if ( blapp.session.isLoggedIn() ) {
				this.doVote(vote);
			} else {
				blapp.refs.get( "header" ).showLogin(
					() => {
						if ( blapp.session.isLoggedIn() ) {
							this.refreshVoteResult();
						}
					}
				);			
			}
		}
	}

	doVote(vote){
		const me = blapp.session.getMe();

		if(me.statusBuyer == 1) {
			this.triggerAlert( "Please confirm your email first!" );
			return;
		}else if(me.statusBuyer != 0) {
			this.triggerAlert( "You need an account in good standing to vote.");
			return;
		}

		blapp.models.fetch(
			"_vote_response"
		,	{
				controller:	"bdp.BLCBDPSubmission"
			,	method:		"voteBDPSubmission"
			,	params:		[ this.props.data.idSubmission, vote ]
			,	refresh:	true
			}
		).then(
			( data ) =>	{
				this.refreshVoteResult();
			}
		);
	}

	refreshVoteResult() {
		blapp.models.fetch(
			"_vote_result"
		,	{
				controller:	"bdp.BLCBDPSubmission"
			,	method:		"getVoteBDPSubmission"
			,	params:		[ this.props.data.idSubmission ]
			,	refresh:	true
			}
		).then(
			( data ) =>	{
				this.setState({vote: data});
			}
		);
	}

  triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent, 'Continue');
	}

	fetchPersonalizeData(){
		if(this._callbackRegistered == null){
			this._callbackRegistered = this.updatePersonalizedData;
		}
		blapp.personalized.fetchPersonalizedDataForBDPSubmission( this.props.data.idSubmission, this.updatePersonalizedData);
	}

	updatePersonalizedData = ( data ) => {
		if ( data && data.dataBDP ) {
			this.setState( { vote: data.dataBDP.nVote } );
		}
	}
}